<script>
import Breadcrumbs from '@/components/Breadcrumbs'
import MgmtButtons from '@/components/MgmtButtons'
import CollectionBar from '@/components/CollectionBar'
import StaticTabs from '@/components/StaticTabs'
import { get, getAll, edit, save, remove } from '@/api'
import MainMixin from '@/views/Main.vue'

export default {
  mixins: [MainMixin],
  components: {
    Breadcrumbs,
    MgmtButtons,
    StaticTabs,
    CollectionBar,
  },
  computed: {
    tabHeight () {
      return this.$store.getters.height - 175
    },
  },
  data: function () {
    return {
      view: 'view',
      activeTab: this.tab,
      acl: {},
      breadcrumbs: [],
      loadingCollbar: false,
      scrollBusy: false,
    }
  },
  methods: {
  },
  mounted () {
    // check object already loaded from before route
    if (!this.loaded) {
      this.loadAcl()
      this.load()
    }
  },
}
</script>
